const IndexPage = () => {
  return <h1>Hello World</h1>;
};

export default IndexPage;
